import React from 'react';
import {Root, Content} from '@radix-ui/react-collapsible';
import styles from './collapsible.module.scss';

interface CollapsibleProps {
  open: boolean;
  children: React.ReactNode;
  className?: string;
}

const Collapsible = ({
  open,
  children,
}: CollapsibleProps) => {
  return (
    <Root open={open} className={styles.root}>
      <Content className={styles.content} asChild>
        {children}
      </Content>
    </Root>
  );
};
Collapsible.displayName = 'Collapsible';

export default Collapsible;
